/* global  moment, _ */
import './style.less';
import activityTemplate from 'modals/assignActivity/template.html';
import activityController from 'modals/assignActivity/controller';
import { orderBy } from 'lodash';

export default function($log, $stateParams, $filter, $uibModal, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.resultsQueried = false;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.pagination = {
    currentPage: 1,
    numPerPage: 15,
    setPage: pageNo => {
      vm.pagination.currentPage = pageNo;
    }
  };

  vm.toggleRow = item => (item.displayInfo = !item.displayInfo);

  vm.getters = {
    activityName: val => {
      return _.isEmpty(vm.activityDict[val.activity_id]) ? 'Archived Activity' : vm.activityDict[val.activity_id].name;
    },
    activityCredits: val => {
      return _.isEmpty(vm.activityDict[val.activity_id]) ? 0 : vm.activityDict[val.activity_id].credits;
    },
    lastUpdated: val => {
      return moment(val.updated_at, 'x').unix();
    }
  };

  vm.headers = [
    { title: 'Last Updated', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 ', sort: 'sortDate' },
    { title: 'Activity', class: 'col-lg-5 col-md-5 col-sm-5 col-xs-5', sort: 'name' },
    { title: 'Assigned by', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2 ', sort: 'progress.assigned_by' },
    { title: 'Status', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1 ', sort: 'progress.completed' },
    { title: '', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' }
  ];

  vm.assignActivity = () => {
    $uibModal.open({
      template: activityTemplate,
      backdrop: true,
      size: 'lg',
      windowClass: 'modal',
      controller: activityController
    });
  };

  function activate() {
    $log.debug('Activity Progress Component Activated');
    vm.loaded = false;
    vm.error = {};

    ApiClass.activitiesGet(
      { manage: false, profile_uid },
      {},
      {
        queryParams: {
          'filter:progress': true
        }
      }
    )
      .then(({ data: { items: activities } }) => {
        vm.activities = orderBy(activities, ['progress.created_at'], ['desc']);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/progressActivities/controller.js